/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

import { BaseService } from '../base-service';
import { ApiConfiguration } from '../api-configuration';
import { StrictHttpResponse } from '../strict-http-response';

import { apiMasterHeaderFooterIconEditFloatIconPost } from '../fn/header-footer/api-master-header-footer-icon-edit-float-icon-post';
import { ApiMasterHeaderFooterIconEditFloatIconPost$Params } from '../fn/header-footer/api-master-header-footer-icon-edit-float-icon-post';
import { apiMasterHeaderFooterIconEditHeaderFooterPost } from '../fn/header-footer/api-master-header-footer-icon-edit-header-footer-post';
import { ApiMasterHeaderFooterIconEditHeaderFooterPost$Params } from '../fn/header-footer/api-master-header-footer-icon-edit-header-footer-post';
import { apiMasterHeaderFooterIconGetFloatInfoGet } from '../fn/header-footer/api-master-header-footer-icon-get-float-info-get';
import { ApiMasterHeaderFooterIconGetFloatInfoGet$Params } from '../fn/header-footer/api-master-header-footer-icon-get-float-info-get';
import { apiMasterHeaderFooterIconGetHeaderFooterInfoGet } from '../fn/header-footer/api-master-header-footer-icon-get-header-footer-info-get';
import { ApiMasterHeaderFooterIconGetHeaderFooterInfoGet$Params } from '../fn/header-footer/api-master-header-footer-icon-get-header-footer-info-get';
import { FloatIconContent } from '../models/float-icon-content';
import { FloatIconContentApiRespModel } from '../models/float-icon-content-api-resp-model';
import { HeaderFooterContent } from '../models/header-footer-content';
import { HeaderFooterContentApiRespModel } from '../models/header-footer-content-api-resp-model';

@Injectable({ providedIn: 'root' })
export class HeaderFooterService extends BaseService {
  constructor(config: ApiConfiguration, http: HttpClient) {
    super(config, http);
  }

  /** Path part for operation `apiMasterHeaderFooterIconEditHeaderFooterPost()` */
  static readonly ApiMasterHeaderFooterIconEditHeaderFooterPostPath = '/api/Master/HeaderFooterIcon/EditHeaderFooter';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterHeaderFooterIconEditHeaderFooterPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterHeaderFooterIconEditHeaderFooterPost$Response(params?: ApiMasterHeaderFooterIconEditHeaderFooterPost$Params, context?: HttpContext): Observable<StrictHttpResponse<HeaderFooterContentApiRespModel>> {
    return apiMasterHeaderFooterIconEditHeaderFooterPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterHeaderFooterIconEditHeaderFooterPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterHeaderFooterIconEditHeaderFooterPost(params?: ApiMasterHeaderFooterIconEditHeaderFooterPost$Params, context?: HttpContext): Observable<HeaderFooterContentApiRespModel> {
    return this.apiMasterHeaderFooterIconEditHeaderFooterPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeaderFooterContentApiRespModel>): HeaderFooterContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterHeaderFooterIconEditFloatIconPost()` */
  static readonly ApiMasterHeaderFooterIconEditFloatIconPostPath = '/api/Master/HeaderFooterIcon/EditFloatIcon';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterHeaderFooterIconEditFloatIconPost()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterHeaderFooterIconEditFloatIconPost$Response(params?: ApiMasterHeaderFooterIconEditFloatIconPost$Params, context?: HttpContext): Observable<StrictHttpResponse<FloatIconContentApiRespModel>> {
    return apiMasterHeaderFooterIconEditFloatIconPost(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterHeaderFooterIconEditFloatIconPost$Response()` instead.
   *
   * This method sends `application/json` and handles request body of type `application/json`.
   */
  apiMasterHeaderFooterIconEditFloatIconPost(params?: ApiMasterHeaderFooterIconEditFloatIconPost$Params, context?: HttpContext): Observable<FloatIconContentApiRespModel> {
    return this.apiMasterHeaderFooterIconEditFloatIconPost$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloatIconContentApiRespModel>): FloatIconContentApiRespModel => r.body)
    );
  }

  /** Path part for operation `apiMasterHeaderFooterIconGetHeaderFooterInfoGet()` */
  static readonly ApiMasterHeaderFooterIconGetHeaderFooterInfoGetPath = '/api/Master/HeaderFooterIcon/GetHeaderFooterInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterHeaderFooterIconGetHeaderFooterInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterHeaderFooterIconGetHeaderFooterInfoGet$Response(params?: ApiMasterHeaderFooterIconGetHeaderFooterInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<HeaderFooterContent>> {
    return apiMasterHeaderFooterIconGetHeaderFooterInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterHeaderFooterIconGetHeaderFooterInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterHeaderFooterIconGetHeaderFooterInfoGet(params?: ApiMasterHeaderFooterIconGetHeaderFooterInfoGet$Params, context?: HttpContext): Observable<HeaderFooterContent> {
    return this.apiMasterHeaderFooterIconGetHeaderFooterInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<HeaderFooterContent>): HeaderFooterContent => r.body)
    );
  }

  /** Path part for operation `apiMasterHeaderFooterIconGetFloatInfoGet()` */
  static readonly ApiMasterHeaderFooterIconGetFloatInfoGetPath = '/api/Master/HeaderFooterIcon/GetFloatInfo';

  /**
   * This method provides access to the full `HttpResponse`, allowing access to response headers.
   * To access only the response body, use `apiMasterHeaderFooterIconGetFloatInfoGet()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterHeaderFooterIconGetFloatInfoGet$Response(params?: ApiMasterHeaderFooterIconGetFloatInfoGet$Params, context?: HttpContext): Observable<StrictHttpResponse<FloatIconContent>> {
    return apiMasterHeaderFooterIconGetFloatInfoGet(this.http, this.rootUrl, params, context);
  }

  /**
   * This method provides access only to the response body.
   * To access the full response (for headers, for example), `apiMasterHeaderFooterIconGetFloatInfoGet$Response()` instead.
   *
   * This method doesn't expect any request body.
   */
  apiMasterHeaderFooterIconGetFloatInfoGet(params?: ApiMasterHeaderFooterIconGetFloatInfoGet$Params, context?: HttpContext): Observable<FloatIconContent> {
    return this.apiMasterHeaderFooterIconGetFloatInfoGet$Response(params, context).pipe(
      map((r: StrictHttpResponse<FloatIconContent>): FloatIconContent => r.body)
    );
  }

}
